import React, {Component} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import {FormattedMessage} from "react-intl";
import AvatarIcon from "../../components/AvatarIcon";
import {successGreen} from "../../themes/colors";
import {isStudent, isTeacher} from "../../utils/userUtility";
import BaseButton from "../../components/button/BaseButton";
import Close from "react-icons/lib/io/close";

@observer
class VideoPleaseWait extends Component {

    render() {
        const {isRoomOpen, peerUser, onClose} = this.props;
        if (!isRoomOpen || !peerUser) {
            return null;
        }
        return (
            <div className="remote remote-waiting">
                <div className={"video-request"}>
                    <button className="video-chat-close" onClick={onClose}>
                        <Close/>
                    </button>

                    {isTeacher() && <FormattedMessage id={peerUser?.projectId ? 'video.chat.empty.room.studio' : 'video.chat.empty.room'} values={{studentName: peerUser?.name}}/>}
                    {isStudent() && <div className={"video-please-wait"}>
                        <div className={"video-please-wait-dots"}>
                            <div className={"dot1"}/>
                            <div className={"dot2"}/>
                            <div className={"dot3"}/>
                            <div className={"dot4"}/>
                            <div className={"dot5"}/>
                        </div>
                        <AvatarIcon style={{background: 'none', border: `2px solid ${successGreen}`, width: '66px', height: '66px'}}
                                    icon={peerUser.avatar} useDefault={true} fullName={peerUser.name}/>
                        <div className={"video-text"}><FormattedMessage id={'video.chat.student.please.wait'} values={{teacherName: peerUser.name}}/></div>
                        <div className={"video-decline-buttons"}>
                            <BaseButton className="video-decline-close" onClick={onClose}
                                        label={<FormattedMessage id={'video.chat.close'}/>}/>
                        </div>
                    </div>}
                </div>
            </div>
        );

    }
}

export default VideoPleaseWait;
